import React, { useRef } from 'react';
import './About.scss';
import { Text } from '../text/Text.tsx';

export const About: React.FC = () => (
  <div className="intro">
    <div className="intro-content">
      <div style={{ marginBottom: 6, textAlign: 'center' }}>
        <Text variant="body">
          {`13+ years, 20+ projects, 15+ customers from 4 countries.`}
        </Text>
      </div>
      <div style={{ marginBottom: 6, textAlign: 'center' }}>
        <Text variant="body">
          {`•`}
        </Text>
      </div>
      <div style={{ marginBottom: 12 }}>
        <Text variant="body">
          {`With a decade of hands-on experience in mobile development, I specialize in creating impactful applications for both iOS and Android platforms. My work ranges from crafting robust native apps to delivering cross-platform solutions with React Native or Flutter.`}
        </Text>
      </div>
      <div style={{ marginBottom: 12 }}>
        <Text variant="body">
          {
            'Beyond coding, I enjoy exploring design principles to enhance user experience, bridging the gap between technology and creativity.'
          }
        </Text>
      </div>
      <div>
        <Text variant="body">
          {
            'Over the years, I have contributed to projects in diverse domains — finance, healthcare, social networking, and more — always with a focus on quality, performance, and usability.'
          }
        </Text>
      </div>
    </div>
  </div>
);
